export default __webpack_public_path__ + "static/media/tag_high.e8f06a6e.png";